import { makeEvent, SOURCE } from '../model';
import toEpochSeconds from '../timestamps';

// Prod has no health time-series, only the current snapshot — so no door
// transitions, but `safetyHoldTs`/`outOfOrderTs` give single markers that anchor
// the incident. With a real series available, use the `heartbeat` adapter.
export function fromHealthSnapshot(fridgeData) {
  if (!fridgeData) return [];
  const out = [];

  if (fridgeData.safetyHold && fridgeData.safetyHoldTs) {
    out.push(
      makeEvent({
        ts: toEpochSeconds(fridgeData.safetyHoldTs),
        source: SOURCE.SNAPSHOT,
        type: 'SAFETY_HOLD',
        summary: 'Safety hold engaged (from current health snapshot)',
        raw: {
          safetyHold: true,
          safetyHoldTs: fridgeData.safetyHoldTs,
          allReasons: fridgeData.allReasons,
        },
      }),
    );
  }
  if (fridgeData.outOfOrder && fridgeData.outOfOrderTs) {
    out.push(
      makeEvent({
        ts: toEpochSeconds(fridgeData.outOfOrderTs),
        source: SOURCE.SNAPSHOT,
        type: 'OUT_OF_ORDER',
        summary: 'Fridge marked out of order (from current health snapshot)',
        raw: { outOfOrder: true, outOfOrderTs: fridgeData.outOfOrderTs },
      }),
    );
  }

  // Work orders carry real dates (date_wo / sch_date).
  for (const wo of fridgeData.activeWorkOrders || []) {
    const ts = toEpochSeconds(wo.date_wo || wo.sch_date);
    if (!ts) continue;
    out.push(
      makeEvent({
        ts,
        source: SOURCE.SNAPSHOT,
        type: 'WORK_ORDER',
        title: `Work order ${wo.wo || ''}`.trim(),
        summary: `${wo.brief_desc || 'work order'}${
          wo.assignto ? ` · ${wo.assignto}` : ''
        }${wo.sch_date ? ` · scheduled ${wo.sch_date}` : ''}`,
        raw: wo,
      }),
    );
  }

  // Open eMaint ticket — no per-ticket date, so anchor it at the snapshot time.
  if (fridgeData.activeTicket) {
    const ts = toEpochSeconds(
      fridgeData.healthStatusTimestamp || fridgeData.timestamp,
    );
    if (ts) {
      out.push(
        makeEvent({
          ts,
          source: SOURCE.SNAPSHOT,
          type: 'EMAINT',
          title: `eMaint ticket ${
            typeof fridgeData.activeTicket === 'string'
              ? fridgeData.activeTicket
              : ''
          }`.trim(),
          summary: 'Open maintenance ticket',
          raw: { activeTicket: fridgeData.activeTicket },
        }),
      );
    }
  }
  return out;
}
